/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupscolumnage2Inputs */

const en_signupscolumnage2 = /** @type {(inputs: Signupscolumnage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age`)
};

const de_signupscolumnage2 = /** @type {(inputs: Signupscolumnage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alter`)
};

/**
* | output |
* | --- |
* | "Age" |
*
* @param {Signupscolumnage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupscolumnage2 = /** @type {((inputs?: Signupscolumnage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupscolumnage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupscolumnage2(inputs)
	return de_signupscolumnage2(inputs)
});
export { signupscolumnage2 as "signupsColumnAge" }